import SiteSummary from "../SiteSummary.tsx";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import {Link, useNavigate} from "react-router";
import {RootState} from "../../../../stores/shopStore.ts";
import {fetchDeliveryMethods, fetchProducts, placeOrder} from "../../../../stores/cart/cartSlice.ts";
import {useAppDispatch, useAppSelector} from "../../../../services/hooks.ts";
import SiteSummaryConsents from "./SiteSummaryCheckout/SiteSummaryConsents.tsx";
import {DeliveryOptionsType, DeliveryType} from "../../../../stores/cart/cartSlice.types.ts";
import {setIsSubmitting} from "../../../../stores/cart/checkoutSlice.ts";
import {useContext} from "react";
import {CheckoutContext} from "../../../../stores/cart/checkoutContext.ts";
import {useTranslation} from "react-i18next";
import {useStore} from "react-redux";
import SpinnerContainer from "../../../../components/Spinner/SpinnerContainer.tsx";
import {CartFinalizeRedirect} from "../../Cart/CartFinalize.tsx";

export default function SiteSummaryCheckout() {
    const {t, i18n} = useTranslation('cart');
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const isIndividual = useAppSelector((state) => state.cart.activeDeliveryOption.individual);
    const isSubmitting = useAppSelector((state) => state.checkout.isSubmitting);
    const store = useStore<RootState>();
    //const state = useAppSelector((state) => state)
    const formRef = useContext(CheckoutContext);

    const onPlaceOrder = async () => {
        const rulesRef = formRef.globalState.rulesRef;
        const privacyRef = formRef.globalState.privacyRef;

        if (!rulesRef?.reportValidity()) return;
        if (!privacyRef?.reportValidity()) return;

        dispatch(setIsSubmitting(true));

        const state = store.getState();
        const hashCart = state.cart.hash;
        const newProducts = await dispatch(fetchProducts()).unwrap();

        if (hashCart !== newProducts.hash) {
            dispatch(fetchDeliveryMethods({
                payment: state.checkout.paymentMethod,
                address: state.checkout.shippingAddress.data,
            }));

            dispatch(setIsSubmitting(false));
            return;
        }

        const activePackageDelivery = state.cart.activeDeliveryOption.packages;
        const activePalletsDelivery = state.cart.activeDeliveryOption.pallets;

        const packageDetails = getCourierDetails(state.cart.deliveryOptions, activePackageDelivery, 'packages');
        const palletsDetails = getCourierDetails(state.cart.deliveryOptions, activePalletsDelivery, 'pallets');

        dispatch(placeOrder({
            'clientInfo': state.checkout.billingAddress.data,
            'delivery': state.checkout.shippingAddress.data,
            'method': {
                'personal': state.cart.activeDeliveryOption.personal,
                'packages': packageDetails ? {
                    id: packageDetails.id || null,
                    name: packageDetails.courier || null,
                } : null,
                'pallets': palletsDetails ? {
                    id: palletsDetails.id || null,
                    name: palletsDetails.courier || null,
                } : null,
                'individual': state.cart.activeDeliveryOption.individual,
            },
            'from': '',
            'payment': state.checkout.paymentMethod,
            'note': state.cart.additionalNotes,
            'locale': i18n.language
        })).unwrap().then((payload) => {
            window.dispatchEvent(new CustomEvent('shop.reloadCart'));

            const data = {
                hash: payload.hash,
                orderNumber: payload?.id || '',
            } as CartFinalizeRedirect;

            navigate('/cart/thanks', {state: data, replace: true});
        })
    };

    return (
        <SiteSummary>
            <SiteSummary.Top>
                <Link to={'/cart'}>
                    <Button variant="outline-success" size="sm" className="px-4 mb-3">
                        {t('summary.edit_cart_button')}
                    </Button>
                </Link>
            </SiteSummary.Top>

            <SiteSummary.Button disabled={isSubmitting} onClick={onPlaceOrder}>
                <SpinnerContainer size={"sm"} enabled={isSubmitting}>
                    <div className="text-white fs-5">
                        <strong>{t('summary.order_button')}</strong>
                    </div>
                </SpinnerContainer>
            </SiteSummary.Button>

            <SiteSummary.Footer>
                {isIndividual !== null && <Container className="my-2">
                    <div className="p-2 text-danger">
                        <strong>UWAGA!!!</strong> Ze względu na swój charakter, przesyłka jest realizowana nie typową
                        metodą transportu. Termin, cena i szczegółowe warunki transportu zostaną uzgodnione
                        telefonicznie.
                    </div>
                </Container>}

                <SiteSummaryConsents/>
            </SiteSummary.Footer>
        </SiteSummary>
    );
}

function getCourierDetails(state: DeliveryOptionsType, active: number | null, type: DeliveryType): null | {
    id: number,
    courier: string
} {
    if (active === null) return null;

    const delivery = state[type];
    if (!Array.isArray(delivery)) return null;
    if (typeof delivery[active] === 'undefined') return null;

    return delivery[active];
}